module.exports = __webpack_public_path__ + "6dd20e7f.svg";